// extracted by mini-css-extract-plugin
export default {"Footer":"leT5nG2031Eq1LP55rTN","DeleteButton":"nLe10ovAL71bPi23PlXh"};